/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type mutationsSendPasswordResetMutationVariables = {
    email: string;
};
export type mutationsSendPasswordResetMutationResponse = {
    readonly sendPasswordReset: boolean;
};
export type mutationsSendPasswordResetMutation = {
    readonly response: mutationsSendPasswordResetMutationResponse;
    readonly variables: mutationsSendPasswordResetMutationVariables;
};



/*
mutation mutationsSendPasswordResetMutation(
  $email: String!
) {
  sendPasswordReset(input: {email: $email})
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "email",
            "variableName": "email"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "sendPasswordReset",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "mutationsSendPasswordResetMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "mutationsSendPasswordResetMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "da4e7de69440037465429ace67a4995a",
    "id": null,
    "metadata": {},
    "name": "mutationsSendPasswordResetMutation",
    "operationKind": "mutation",
    "text": "mutation mutationsSendPasswordResetMutation(\n  $email: String!\n) {\n  sendPasswordReset(input: {email: $email})\n}\n"
  }
};
})();
(node as any).hash = 'bc5673582d8c9a62d97b717c521833f4';
export default node;
